import { render } from "./EditExportDeclaration.vue?vue&type=template&id=ab8bf5d6&scoped=true&ts=true"
import script from "./EditExportDeclaration.vue?vue&type=script&lang=ts"
export * from "./EditExportDeclaration.vue?vue&type=script&lang=ts"

import "./EditExportDeclaration.vue?vue&type=style&index=0&id=ab8bf5d6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8bf5d6"]])

export default __exports__